"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartScrollCurtain = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var fp_1 = require("lodash/fp");
var CURTAIN_WIDTH = 64;
exports.ChartScrollCurtain = function (_a) {
    var chartWidth = _a.chartWidth, chartHeight = _a.chartHeight, disabled = _a.disabled, scrollDirection = _a.scrollDirection;
    var curtainHeight = chartHeight - 1;
    var curtainID = fp_1.uniqueId('scroll-curtain');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("linearGradient", { id: "left-" + curtainID },
            react_1.default.createElement("stop", { offset: "0%", stopColor: "white", stopOpacity: 1 }),
            react_1.default.createElement("stop", { offset: "100%", stopColor: "white", stopOpacity: 0 })),
        react_1.default.createElement("linearGradient", { id: "right-" + curtainID },
            react_1.default.createElement("stop", { offset: "0%", stopColor: "white", stopOpacity: 0 }),
            react_1.default.createElement("stop", { offset: "100%", stopColor: "white", stopOpacity: 1 })),
        !disabled && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("rect", { width: CURTAIN_WIDTH, height: curtainHeight, transform: scrollDirection === 'left'
                    ? "translate(0, 0)"
                    : "translate(" + (chartWidth - CURTAIN_WIDTH) + ", 0)", fill: scrollDirection === 'left'
                    ? "url(#left-" + curtainID + ")"
                    : "url(#right-" + curtainID + ")", pointerEvents: "all" })))));
};
